'use client';

import React from 'react';
import chunk from 'lodash/chunk';
import Box from '@mui/material/Box';
import { Pagination, Virtual } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const BaseSwiper = (props: {
  className: string;
  chunkData: any[];
  chunkSize: number;
  slideClassName: string;
  swiperEle: (data: any) => React.ReactNode;
  bulletSx: Record<string, any>;
  spaceBetween?: number;
  tag?: string;
}) => {
  const {
    className = '',
    chunkData,
    chunkSize,
    slideClassName,
    swiperEle,
    bulletSx = {},
    spaceBetween = 16,
    tag = 'div',
  } = props;
  return (
    <Box
      className={className}
      sx={{
        ...bulletSx,
      }}
    >
      <Swiper
        modules={[Pagination, Virtual]}
        preventClicks={true}
        preventClicksPropagation={true}
        pagination={{
          clickable: true,
        }}
        spaceBetween={spaceBetween}
        className="-m-5"
      >
        {chunk(chunkData, chunkSize).map((item, i) => (
          <SwiperSlide
            key={i}
            className={'list-none p-5 ' + slideClassName}
            tag={tag}
          >
            {item.map((cItem) => swiperEle(cItem))}
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default BaseSwiper;
